import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "max-w-sm mx-auto md:mt-8 p-4 md:border md:border-gray-300 rounded md:shadow-md" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block font-bold flex justify-start"
}, "Email *", -1)
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block font-bold flex justify-start"
}, "Password *", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full px-3 py-2 bg-black text-white border border-black rounded hover:bg-white hover:text-black"
}, " Login ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-6 flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "w-40 h-px my-3 bg-gray-100 border-0 rounded bg-gray-300" }),
  /*#__PURE__*/_createElementVNode("p", { class: "mx-2" }, "ou"),
  /*#__PURE__*/_createElementVNode("hr", { class: "w-40 h-px my-3 bg-gray-100 border-0 rounded bg-gray-300" })
], -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onSubmit"]
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "block font-bold flex justify-start"
}, "Prénom", -1)
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "phoneNumber",
  class: "block font-bold flex justify-start"
}, "Téléphone", -1)
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailRegister",
  class: "block font-bold flex justify-start"
}, "Email *", -1)
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "passwordRegister1",
  class: "block font-bold flex justify-start"
}, "Password *", -1)
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "passwordRegister2",
  class: "block font-bold flex justify-start"
}, "Password *", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full px-3 py-2 mt-8 bg-black text-white rounded"
}, " Register ", -1)
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = ["textContent"]

import { ref} from 'vue';
  import { useRouter } from 'vue-router'
  import { useCurrentCompanyStore } from '../../stores/CurrentCompanyStore'
  import { useUserStore } from '../../stores/UserStore'
  import { storeToRefs } from 'pinia'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  setup(__props) {

  const {login,register } = useUserStore()
  const router = useRouter()
  const {currentCompanyId } = storeToRefs(useCurrentCompanyStore())
  const {userEmail, userFirstName, userLastName, userPhoneNumber,userCompanyId,userId,userRole } = storeToRefs(useUserStore())
  
  let email= ref("")
  let password= ref("")

  let emailRegister=ref("")
  let firstname=ref("")
  let phoneNumber=ref("")
  let passwordRegister1= ref("")
  let passwordRegister2= ref("")
  let message= ref("")
  let chooseToregister = ref(false)

  function toggleLoginRegister(){
    chooseToregister.value = !chooseToregister.value
  }

  async function signIn(){
    const _login = await login(email.value,password.value);
    if (_login){
      message.value = "success";
    }
    else{
      message.value = "wrong email/password";
    }
  }

  async function registration(){
    if (passwordRegister1.value !== passwordRegister2.value) {
      message.value = "The passwords don't match";
      return;
    }
    const _registration = await register(emailRegister.value,passwordRegister1.value,firstname.value,phoneNumber.value);
    if (_registration){
      toggleLoginRegister()
    }
    else{
      message.value = "wrong email/password";
    }
  }

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(chooseToregister))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(signIn, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
                required: "",
                class: "w-full px-3 py-2 border rounded"
              }, null, 512), [
                [_vModelText, _unref(email)]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "password",
                placeholder: "Password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
                required: "",
                class: "w-full px-3 py-2 border rounded"
              }, null, 512), [
                [_vModelText, _unref(password)]
              ])
            ]),
            _hoisted_8
          ], 40, _hoisted_3),
          _hoisted_9,
          _createElementVNode("div", { class: "mt-3 flex justify-center" }, [
            _createElementVNode("button", {
              onClick: toggleLoginRegister,
              class: "w-full py-2 border border-black rounded hover:bg-black hover:text-white"
            }, "Créer mon compte")
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(chooseToregister))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(registration, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "firstname",
                placeholder: "Prénom",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(firstname) ? (firstname).value = $event : firstname = $event)),
                required: "",
                class: "w-full px-3 py-2 border rounded"
              }, null, 512), [
                [_vModelText, _unref(firstname)]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "phoneNumber",
                placeholder: "Téléphone",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(phoneNumber) ? (phoneNumber).value = $event : phoneNumber = $event)),
                required: "",
                class: "w-full px-3 py-2 border rounded"
              }, null, 512), [
                [_vModelText, _unref(phoneNumber)]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "emailRegister",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(emailRegister) ? (emailRegister).value = $event : emailRegister = $event)),
                required: "",
                class: "w-full px-3 py-2 border rounded"
              }, null, 512), [
                [_vModelText, _unref(emailRegister)]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "passwordRegister1",
                placeholder: "Password",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(passwordRegister1) ? (passwordRegister1).value = $event : passwordRegister1 = $event)),
                required: "",
                class: "w-full px-3 py-2 border rounded"
              }, null, 512), [
                [_vModelText, _unref(passwordRegister1)]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "passwordRegister2",
                placeholder: "Password",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(passwordRegister2) ? (passwordRegister2).value = $event : passwordRegister2 = $event)),
                required: "",
                class: "w-full px-3 py-2 border rounded"
              }, null, 512), [
                [_vModelText, _unref(passwordRegister2)]
              ])
            ]),
            _hoisted_22
          ], 40, _hoisted_11)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("span", {
          id: "message",
          textContent: _toDisplayString(_unref(message)),
          class: "w-full text-red-500 text-center"
        }, null, 8, _hoisted_25)
      ])
    ])
  ]))
}
}

})